import { useEffect } from "react";
import { getHash } from "lib/routing";

// Anchor scroll, e.g. /url#my_section_name but works with content loaded dynamically
export const useScrollToAnchor = () => {
  useEffect(() => {
    const anchorElement = document.getElementById(getHash());
    if (anchorElement) anchorElement.scrollIntoView();
  }, []);
};
